// src/utils/dataUtils.js

export function filterRawDataForSelectedDate(jsonData, selectedDate, dateTo) {
	if (!jsonData) {
		return null
	}

	var filteredData = null

	try {
		filteredData = JSON.parse(jsonData)
	} catch (error) {
		console.warn('Error parsing JSON data:', error, jsonData)
		return null
	}

	// TODO: For testing and debugging, removes all locations except the first 10

	// If query param slice is set, slice the locations array using the given number
	if (window.location.search.includes('slice')) {
		console.warn('Slicing locations for testing')
		var sliceNum = parseInt(new URLSearchParams(window.location.search).get('slice'), 10)
		filteredData.locations = filteredData.locations.slice(0, sliceNum)
	}

	console.warn('filterRawDataForSelectedDate', filteredData, selectedDate)

	const locationDays = {}
	const today = new Date()
	today.setHours(0, 0, 0, 0)

	for (const location of filteredData.locations) {
		const dateStr = new Date(location.timestamp).toShortDateString()
		locationDays[dateStr] = (locationDays[dateStr] || 0) + 1
	}
	filteredData.locationDays = locationDays

	console.warn('Location days:', locationDays)

	if (!selectedDate) {
		const validDates = Object.entries(locationDays)
			.filter(([dateStr, count]) => {
				const date = new Date(dateStr)
				// Exclude dateTo as it will not have any data from the cloud
				return count >= 1 && date < today && date.toShortDateString() != dateTo
			})
			.map(([date]) => new Date(date))

		if (validDates.length === 0) {
			filteredData.selectedDate = null
			return filteredData
		}

		selectedDate = new Date(Math.max(...validDates))
	}

	filteredData.selectedDate = selectedDate

	const targetDate = new Date(selectedDate)
	targetDate.setHours(0, 0, 0, 0)
	const endDate = new Date(selectedDate)
	endDate.setDate(endDate.getDate() + 1)
	// End date is set to the end of the day (04:00 + 12h) to make sure we include all data for trips starting before 04:00 and ending after 04:00
	endDate.setHours(16, 0, 0, 0)

	let fromIndex = 0
	let toIndex = 0

	for (let i = 0; i < filteredData.locations.length; i++) {
		const locationDate = new Date(filteredData.locations[i].timestamp)
		if (locationDate <= targetDate) {
			fromIndex = i
		}
		if (locationDate <= endDate) {
			toIndex = i
		} else {
			break
		}
	}

	if (filteredData.locations.length) {
		const filteredFromDate = new Date(filteredData.locations[fromIndex].timestamp)
		const filteredToDate = new Date(filteredData.locations[toIndex].timestamp)
		filteredData.locations = filteredData.locations.slice(fromIndex, toIndex)
		filteredData.beacons = filteredData.beacons.filter((beacon) => {
			const beaconDate = new Date(beacon.timestamp)
			return beaconDate >= filteredFromDate && beaconDate <= filteredToDate
		})
	}

	console.warn('filterRawDataForSelectedDate result', filteredData)

	return filteredData
}

// Add Date prototype extension
if (!Date.prototype.toShortDateString) {
	Date.prototype.toShortDateString = function () {
		const year = this.getFullYear()
		const month = String(this.getMonth() + 1).padStart(2, '0')
		const day = String(this.getDate()).padStart(2, '0')
		return `${year}-${month}-${day}`
	}
}
